import { Product } from '../../../models/piramide/Product';

export class PlacaVideo extends Product {
  $caracteristicas: {
    BackPlate: number;
    DP: number;
    USBTypeC: null;
    altura: number;
    ancho: null;
    block_vga_water: number;
    cant_cooler: null;
    cant_procesos: null;
    cantidad: number;
    capacidad: number;
    chipset: string;
    doble_puente: number;
    dvi: number;
    dvi_analogico: number;
    espesor: null;
    fabricante_chipset: string;
    fecha_update: string;
    hdmi: number;
    id_producto: number;
    largo: number;
    marca: string;
    mem_bits: number;
    modelo: string;
    nivel_gpu: null;
    puente_id: null;
    rca: number;
    svideo: number;
    tecnologia: string;
    tipo: string;
    tipo_mem: string;
    tipo_multiplaca: string;
    tipo_procesos: string;
    vel_cor_turbo: null;
    vel_core: number;
    vel_mem: number;
    vga: number;
    video_in: number;
    w: number;
    w_total: number;
    _2plus: number;
    _6pines: number;
    _16pines: number;
    _16pines_conexion: number;
    adaptador_16pines: number;
  };
  public constructor(product: Product) {
    super(product);
    if (![6, 62, 116].includes(product.id_subcategoria)) {
      throw 'esto no es una placa de video';
    }
  }
}
